var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import * as types from './chatroomActionTypes';

var initialState = {
    isInProgress: false,
    chatroomId: '',
    chatroomName: '',
    metaData: '',
    users: {},
    messages: [],
    showPreview: false,
    uploadImage: false,
    selectedMessage: {
        id: false,
        date: 0
    },
    file: '',
    showNotEnabledPopup: false,
    showValidationPopup: false,
    hasError: false,
    errorMessage: ''

};

var sendMessage = function sendMessage(state, action) {
    return _extends({}, state, {
        isInProgress: true
    });
};

var sendMessageSuccess = function sendMessageSuccess(state, action) {
    return _extends({}, state, {
        isInProgress: false,
        showPreview: false,
        uploadImage: false
    });
};

var sendMessageError = function sendMessageError(state, action) {
    var errorMessage = action.errorMessage;

    return _extends({}, state, {
        isInProgress: false,
        hasError: true,
        showPreview: false,
        uploadImage: false,
        errorMessage: errorMessage
    });
};

var selectMessage = function selectMessage(state, action) {
    var messageId = action.messageId,
        date = action.date;

    return _extends({}, state, {
        selectedMessage: {
            id: messageId,
            date: date
        }
    });
};

var unselectMessage = function unselectMessage(state, action) {
    return _extends({}, state, {
        selectedMessage: {
            id: false,
            date: 0
        }
    });
};

var reportMessageSuccess = function reportMessageSuccess(state, action) {
    return _extends({}, state, {
        showValidationPopup: true
    });
};

var hideValidationPopup = function hideValidationPopup(state, action) {
    return _extends({}, state, {
        showValidationPopup: false
    });
};

var reportMessageError = function reportMessageError(state, action) {
    var errorMessage = action.errorMessage;

    return _extends({}, state, {
        isInProgress: false,
        hasError: true,
        errorMessage: errorMessage
    });
};

var retrieveMessage = function retrieveMessage(state, action) {
    var key = action.key,
        uid = action.uid,
        message = action.message,
        messageType = action.messageType,
        date = action.date,
        isReported = action.isReported,
        isInappropriate = action.isInappropriate;

    var users = state.users;
    if (typeof users === 'undefined' || typeof users[uid] === 'undefined') {
        var _extends2;

        users = _extends({}, state.users, (_extends2 = {}, _extends2[uid] = {
            username: '',
            avatar: ''
        }, _extends2));
    }

    return _extends({}, state, {
        users: users,
        messages: [].concat(state.messages, [{
            key: key,
            uid: uid,
            message: message,
            type: messageType,
            date: date,
            isReported: isReported,
            isInappropriate: isInappropriate
        }])
    });
};

var updateMessage = function updateMessage(state, action) {
    var messages = action.messages;

    return _extends({}, state, {
        messages: messages
    });
};

var addUserError = function addUserError(state, action) {
    var errorMessage = action.errorMessage;

    return _extends({}, state, {
        isInProgress: false,
        hasError: true,
        errorMessage: errorMessage
    });
};

var enterChatroom = function enterChatroom(state, action) {
    var chatroomId = action.chatroomId,
        chatroomName = action.chatroomName;

    return _extends({}, state, {
        chatroomId: chatroomId,
        chatroomName: chatroomName
    });
};

var leaveChatroom = function leaveChatroom(state, action) {
    return _extends({}, state, {
        isInProgress: false,
        chatroomId: '',
        chatroomName: '',
        metaData: '',
        users: [],
        messages: [],
        showNotEnabledPopup: false,
        showValidationPopup: false,
        hasError: false,
        errorMessage: ''
    });
};

var getChatroomMetaData = function getChatroomMetaData(state, action) {
    var metaData = action.metaData;

    return _extends({}, state, {
        metaData: metaData
    });
};

var retrieveUserSuccess = function retrieveUserSuccess(state, action) {
    var _extends3;

    var userId = action.userId,
        username = action.username,
        avatar = action.avatar,
        isAdmin = action.isAdmin;

    return _extends({}, state, {
        users: _extends({}, state.users, (_extends3 = {}, _extends3[userId] = {
            username: username,
            avatar: avatar,
            isAdmin: isAdmin
        }, _extends3))
    });
};

var retrieveUserError = function retrieveUserError(state, action) {
    var errorMessage = action.errorMessage;

    return _extends({}, state, {
        hasError: true,
        errorMessage: errorMessage
    });
};

var cleanMessage = function cleanMessage(state, action) {
    return _extends({}, state, {
        messages: []
    });
};

var sendPreview = function sendPreview(state, action) {
    var file = action.file;

    return _extends({}, state, {
        showPreview: true,
        file: file
    });
};

var cancelPreview = function cancelPreview(state, action) {
    return _extends({}, state, {
        showPreview: false,
        file: ''
    });
};

var startUpload = function startUpload(state, action) {
    return _extends({}, state, {
        showPreview: false,
        uploadImage: true
    });
};

var showNotEnabledPopup = function showNotEnabledPopup(state, action) {
    return _extends({}, state, {
        showNotEnabledPopup: true
    });
};

var hideNotEnabledPopup = function hideNotEnabledPopup(state, action) {
    return _extends({}, state, {
        showNotEnabledPopup: false
    });
};

var error = function error(state, action) {
    var errorMessage = action.errorMessage;

    return _extends({}, state, {
        hasError: true,
        errorMessage: errorMessage
    });
};

export var chatroomReducers = function chatroomReducers() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case types.SEND_MESSAGE:
            return sendMessage(state, action);
        case types.SEND_MESSAGE_SUCCESS:
            return sendMessageSuccess(state, action);
        case types.SEND_MESSAGE_ERROR:
            return sendMessageError(state, action);
        case types.SELECT_MESSAGE:
            return selectMessage(state, action);
        case types.UNSELECT_MESSAGE:
            return unselectMessage(state, action);
        case types.REPORT_MESSAGE_SUCCESS:
            return reportMessageSuccess(state, action);
        case types.REPORT_MESSAGE_ERROR:
            return reportMessageError(state, action);
        case types.HIDE_VALIDATION_POPUP:
            return hideValidationPopup(state, action);
        case types.RETRIEVE_MESSAGE:
            return retrieveMessage(state, action);
        case types.UPDATE_MESSAGE:
            return updateMessage(state, action);
        case types.ADDUSER_ERROR:
            return addUserError(state, action);
        case types.ENTER_CHATROOM:
            return enterChatroom(state, action);
        case types.LEAVE_CHATROOM:
            return leaveChatroom(state, action);
        case types.GET_CHATROOM_METADATA:
            return getChatroomMetaData(state, action);
        case types.RETRIEVE_USER_SUCCESS:
            return retrieveUserSuccess(state, action);
        case types.RETRIEVE_USER_ERROR:
            return retrieveUserError(state, action);
        case types.CLEAN_MESSAGES:
            return cleanMessage(state, action);
        case types.SEND_PREVIEW:
            return sendPreview(state, action);
        case types.CANCEL_PREVIEW:
            return cancelPreview(state, action);
        case types.START_UPLOAD:
            return startUpload(state, action);
        case types.SHOW_NOT_ENABLED_POPUP:
            return showNotEnabledPopup(state, action);
        case types.HIDE_NOT_ENABLED_POPUP:
            return hideNotEnabledPopup(state, action);
        case types.ERROR:
            return error(state, action);
        default:
            return state;
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/nm-react-chat/es/components/Chatroom/chatroomReducers.js
// module id = 230
// module chunks = 0